import { useContext } from 'react';

import DragHandleIcon from '@/assets/svg/bx-align-justify.svg?react';
import { Button } from '@/components/buttons';
import { cn } from '@/lib/utils';

import { SortableItemContext } from './SortableListItem';

type Props = {
  isActive: boolean;
};

const DraggableHandle = ({ isActive }: Props) => {
  const { attributes, listeners, ref } = useContext(SortableItemContext);

  return (
    <div className="flex items-center" {...attributes} {...listeners} ref={ref}>
      <Button size="icon-small" variant="ghost" className="cursor-grab">
        <DragHandleIcon className={cn('size-3.5', isActive && 'cursor-grabbing')} />
      </Button>
    </div>
  );
};

export default DraggableHandle;
